import { useRecentToolsStore } from '@/stores/useRecentToolsStore';
import { pluginRegistry } from '@/plugins/pluginRegistry';
import { ToolCard } from './ToolCard';
import { Clock } from 'lucide-react';

export function RecentlyUsed() {
  const { recentTools, trackVisit } = useRecentToolsStore();
  const recent = recentTools.slice(0, 3);

  const recentPlugins = recent
    .map((r) => pluginRegistry.getPluginById(r.pluginId))
    .filter((p): p is NonNullable<typeof p> =>
      p !== undefined && pluginRegistry.isPluginEnabled(p.id) && (p.navigation?.length ?? 0) > 0
    );

  if (recentPlugins.length === 0) {
    return (
      <div className="rounded-lg border border-dashed border-border/60 bg-card/50 p-6 text-center" data-testid="recent-empty">
        <Clock className="mx-auto h-8 w-8 text-muted-foreground/30" />
        <p className="mt-2 text-sm text-muted-foreground">
          Starte mit einem Tool aus der Suite
        </p>
      </div>
    );
  }

  return (
    <section data-testid="recently-used">
      <h2 className="mb-3 text-sm font-semibold">Zuletzt verwendet</h2>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {recentPlugins.map((plugin) => {
          const nav = plugin.navigation![0];
          return (
            <ToolCard
              key={plugin.id}
              id={plugin.id}
              name={plugin.name}
              description={plugin.description}
              icon={nav.icon}
              href={nav.path}
              group={plugin.group}
              compact
              onClick={() => trackVisit(plugin.id)}
            />
          );
        })}
      </div>
    </section>
  );
}
